// Combat's default soft target when the game passes no chooser: the nearest live candidate in front of the attacker,
// inside a range and a half angle. A game binds `chooseTarget` (targeting.ts: the scored chooser, with lock-on on
// top) to its weights and passes that instead; the shapes are targeting.ts's.

import type { TargetCandidate, TargetFrom } from "./targeting";

/** Pick a target: an id, or null. */
export type ChooseTarget = (from: TargetFrom, candidates: readonly TargetCandidate[]) => number | null;

/** The nearest live candidate within `range` m whose bearing is within `halfAngle` rad of the facing (ties: lower id). */
export function nearestInFront(o: { range: number; halfAngle: number }): ChooseTarget {
  return (from, candidates) => {
    let best: number | null = null;
    let bestD = Infinity;
    const fx = Math.sin(from.facing);
    const fz = Math.cos(from.facing);
    const cos = Math.cos(o.halfAngle);
    for (const c of candidates) {
      if (!c.alive) continue;
      const dx = c.pos[0] - from.pos[0];
      const dz = c.pos[2] - from.pos[2];
      const d = Math.hypot(dx, dz);
      if (d > o.range) continue;
      if (d > 1e-6 && (dx * fx + dz * fz) / d < cos) continue;
      if (d < bestD - 1e-9 || (Math.abs(d - bestD) <= 1e-9 && best !== null && c.id < best)) {
        best = c.id;
        bestD = d;
      }
    }
    return best;
  };
}
